import React from "react";

import { ODC_WEEKLY_BUCKET_COLUMN_WIDTHS } from "./weeklyEACODCColumns";
import { formatCellValue } from "./weeklyEACFormat";
import { getBucketForWeek, round2 } from "./weeklyEACCalculations";

// Mirrors Direct Labor's own weekly total row — Unburden Cost/Burden Cost summed across all ODC
// records per week; static columns are left blank (not meaningful to sum).
export default function WeeklyEACODCWeeklyTotalRow({
  odcDetails,
  weekColumns,
  staticColumns,
  spacerWidth,
}) {
  return (
    <tr className="totalRow">
      {spacerWidth > 0 && <td style={{ minWidth: spacerWidth, maxWidth: spacerWidth }} />}
      {staticColumns.map((column) => (
        <td key={column.label} style={{ minWidth: column.width, maxWidth: column.width }} />
      ))}
      {weekColumns.map((week, index) => {
        const totalUnburdenCost = odcDetails.reduce((sum, odc) => {
          const bucket = getBucketForWeek(odc, week.weekStartDate);
          return sum + (bucket ? round2(Number(bucket.unburdenCost) || 0) : 0);
        }, 0);
        const totalBurdenCost = odcDetails.reduce((sum, odc) => {
          const bucket = getBucketForWeek(odc, week.weekStartDate);
          return sum + (bucket ? round2(Number(bucket.burdenCost) || 0) : 0);
        }, 0);
        const isLastWeek = index === weekColumns.length - 1;
        return (
          <React.Fragment key={week.weekStartDate}>
            <td
              style={{
                minWidth: ODC_WEEKLY_BUCKET_COLUMN_WIDTHS.unburdenCost,
                maxWidth: ODC_WEEKLY_BUCKET_COLUMN_WIDTHS.unburdenCost,
                borderLeft: "1px solid #ccc",
                paddingLeft: "4px",
              }}
              title={formatCellValue(totalUnburdenCost, "currency")}
            >
              {formatCellValue(totalUnburdenCost, "currency")}
            </td>
            <td
              style={{
                minWidth: ODC_WEEKLY_BUCKET_COLUMN_WIDTHS.burdenCost,
                maxWidth: ODC_WEEKLY_BUCKET_COLUMN_WIDTHS.burdenCost,
                ...(isLastWeek ? { borderRight: "1px solid #ccc" } : {}),
              }}
              title={formatCellValue(totalBurdenCost, "currency")}
            >
              {formatCellValue(totalBurdenCost, "currency")}
            </td>
          </React.Fragment>
        );
      })}
    </tr>
  );
}
